import { React, useEffect, useState } from 'react';
import { PAGE_ROUTE, API_URL } from '../../shared/constant';
import { NavLink, useNavigate } from 'react-router-dom';
import TableComponent from '../../shared/table';
import LoaderComponent from '../../shared/loader';
import { AiOutlineSearch } from 'react-icons/ai';
import { Form } from 'react-bootstrap';
import moment from 'moment/moment';
import axios from 'axios';

const PostsListComponent = () => {
    const [search, setSearch] = useState('');
    const [status, setStatus] = useState('draft');
    const [articleType, setArticleType] = useState('');
    const [orderBy, setOrderBy] = useState('');
    const [orderDirection, setOrderDirection] = useState('desc');
    const [currentPage, setcurrentPage] = useState(1);
    const [isNext, setNext] = useState(false);
    const [isPrev, setPrev] = useState(false);

    const columns = [
        {
            field: 'id',
            lable: 'ID'
        }, {
            field: 'title',
            lable: 'Title'
        }, {
            field: 'article_type',
            lable: 'Article Type'
        },
        {
            field: 'views',
            lable: 'Views'
        },
        {
            field: 'created_at',
            lable: 'Created At'
        },
        {
            field: 'updated_at',
            lable: 'Last Update'
        }
    ];
    const [total, setTotal] = useState(0);
    const [totalCount, setTotalCount] = useState(0);
    const [todayCount, setTodayCount] = useState(0);
    const [todayPostCount, setTodayPostCount] = useState(0);
    const [todayQuoteCount, setTodayQuoteCount] = useState(0);
    const [isLoading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [isRecall, setIsRecall] = useState(false);

    const nextPage = () => {
        let page = currentPage + 1;
        setcurrentPage(page);
        getPosts(page, status, articleType, orderBy, orderDirection);
    }

    const prevPage = () => {
        let page = currentPage - 1;
        setcurrentPage(page);
        getPosts(page, status, articleType, orderBy, orderDirection);
    }

    useEffect(() => {
        const articleType = localStorage.getItem('article_type');
        if (articleType) {
            setArticleType(articleType);
        }
        getPosts(1, "", articleType, "", "");
        getPostsCount();
    }, []);

    useEffect(() => {
        isRecall && getPosts(currentPage, status, articleType, orderBy, orderDirection);
    }, [isRecall]);

    const getPosts = (page, statusFilter, articleTypeFilter, orderByFilter, orderDirectionFilter) => {
        setLoading(true);
        const filters = {
            per_page: 30,
            page: page
        };
        
        if (statusFilter) {
            filters.status = statusFilter;
        }
        
        if (articleTypeFilter) {
            filters.article_type = articleTypeFilter;
        }

        if (search) {
            filters.search = search;
        }
        
        if (orderByFilter) {
            filters.order_by = orderByFilter;
            filters.order_direction = orderDirectionFilter || 'desc';
        }

        axios.post(API_URL.ADMIN_POSTS_LIST, filters).then(res => {
            if (res.data.status === 1) {
                const postsData = res.data.data.data || [];
                setData(postsData);
                setTotal(res.data.data.total || 0);
                
                postsData.map((element) => {
                    element.created_at = moment(element.created_at).format('lll');
                    element.updated_at = moment(element.updated_at).format('lll');
                    return element;
                });

                if (res.data.data.current_page < res.data.data.last_page) {
                    setNext(true);
                } else {
                    setNext(false);
                }
                
                if (res.data.data.current_page > 1) {
                    setPrev(true);
                } else {
                    setPrev(false);
                }
            }
            setIsRecall(false);
            setLoading(false);
        }, error => {
            setLoading(false);
        });
    };

    const getPostsCount = () => {
        axios.post(API_URL.ADMIN_POSTS_COUNT, {}).then(res => {
            if (res.data.status === 1) {
                setTotalCount(res.data.data.total_count || 0);
                setTodayCount(res.data.data.today_count || 0);
                setTodayPostCount(res.data.data.today_post_count || 0);
                setTodayQuoteCount(res.data.data.today_quote_count || 0);
            }
        });
    };

    const onDelete = (item) => {
        if (window.confirm('Are you sure you want to delete this post?')) {
            axios.post(API_URL.ADMIN_POSTS_DELETE, { id: item.id }).then((response) => {
                if (response.data.status === 1) {
                    setIsRecall(true);
                }
            });
        }
    };

    const onEdit = (item) => {
        navigate(PAGE_ROUTE.ADMIN_POSTS_EDIT + item.id, { replace: true });
    };

    const onFaqs = (item) => {
        navigate(PAGE_ROUTE.ADMIN_POSTS_FAQS + item.id, { replace: true });
    };

    const onCopy = (row) => {
        const url = `https://statush.com/${row.article_type}/${row.slug}`;
        navigator.clipboard.writeText(url).then(() => {
            alert('URL copied to clipboard');
        }).catch(() => {
            alert('Failed to copy');
        });
    };

    const updateStatus = (val) => {
        setStatus(val);
        getPosts(1, val, articleType, orderBy, orderDirection);
    };

    const updateArticleType = (val) => {
        localStorage.setItem('article_type', val);
        setArticleType(val);
        getPosts(1, status, val, orderBy, orderDirection);
    };

    const updateOrderBy = (val) => {
        setOrderBy(val);
        getPosts(1, status, articleType, val, orderDirection);
    };

    const updateOrderDirection = (val) => {
        setOrderDirection(val);
        getPosts(1, status, articleType, orderBy, val);
    };

    return (
        <div>
            <div className='card'>
                <div className='card-body'>
                    <h4 className='card-title'>Posts ({total}): Total Views ({totalCount}), Today's Views ({todayCount}), Today's Posts ({todayPostCount}), Today's Quotes ({todayQuoteCount})

                        <nav aria-label="Page navigation example">
                            <div className="input-group mt-3">
                                <div className="form-outline">
                                    <input 
                                        type="search" 
                                        value={search} 
                                        placeholder="Search Here...." 
                                        onChange={e => setSearch(e.target.value.trim())} 
                                        className="form-control" 
                                    />
                                </div>

                                <button 
                                    type="button" 
                                    style={{ borderRadius: '3px' }} 
                                    className="btn btn-primary ms-2" 
                                    onClick={() => getPosts(1, status, articleType, orderBy, orderDirection)}
                                >
                                    <AiOutlineSearch style={{ fontSize: '20px' }} />
                                </button>

                                <div className='input-form ms-3'>
                                    <Form.Select 
                                        aria-label="Status"
                                        value={status}
                                        onChange={(event) => { updateStatus(event.target.value) }}
                                    >
                                        <option value="">All Status</option>
                                        <option value="published">Published</option>
                                        <option value="draft">Draft</option>
                                    </Form.Select>
                                </div>

                                <div className='input-form ms-3'>
                                    <Form.Select 
                                        aria-label="Article Type"
                                        value={articleType}
                                        onChange={(event) => { updateArticleType(event.target.value) }}
                                    >
                                        <option value="">All Types</option>
                                        <option value="ai">AI</option>
                                        <option value="credit-score-debt">Credit Score & Debt</option>
                                        <option value="credit-cards-banking">Credit Cards & Banking</option>
                                        <option value="finance-statistics">Finance & Statistics</option>
                                        <option value="money">Money</option>
                                        <option value="wealth">Wealth</option>
                                        <option value="entrepreneur">Entrepreneur</option>
                                        <option value="business">Business</option>
                                        <option value="investing">Investing</option>
                                        <option value="leadership">Leadership</option>
                                        <option value="side-hustles">Side Hustles</option>
                                        <option value="retirement-planning">Retirement Planning</option>
                                        <option value="real-estate">Real Estate</option>
                                        <option value="quotes">Quotes</option>
                                    </Form.Select>
                                </div>

                                <div className='input-form ms-3'>
                                    <Form.Select 
                                        aria-label="Order By"
                                        value={orderBy}
                                        onChange={(event) => { updateOrderBy(event.target.value) }}
                                    >
                                        <option value="">Default Order</option>
                                        <option value="views">Views</option>
                                        <option value="created_at">Created At</option>
                                        <option value="updated_at">Updated At</option>
                                    </Form.Select>
                                </div>

                                {orderBy && (
                                    <div className='input-form ms-3'>
                                        <Form.Select 
                                            aria-label="Order Direction"
                                            value={orderDirection}
                                            onChange={(event) => { updateOrderDirection(event.target.value) }}
                                        >
                                            <option value="desc">Descending</option>
                                            <option value="asc">Ascending</option>
                                        </Form.Select>
                                    </div>
                                )}

                            </div>
                            <ul className="pagination justify-content-end">
                                <li>
                                    <NavLink to={PAGE_ROUTE.ADMIN_POSTS_CREATE} className="btn btn-outline-success btn-sm me-2">
                                        Add
                                    </NavLink>
                                </li>
                                <li className="page-item disabled">
                                    {isPrev ? <button className="btn btn-outline-primary btn-sm me-2" onClick={prevPage}>Previous</button> : ""}
                                </li>
                                <li className="page-item">
                                    {isNext ? <button className="btn btn-outline-primary btn-sm" onClick={nextPage}>Next</button> : ""}
                                </li>
                            </ul>
                        </nav>
                    </h4>

                    {
                        isLoading && <LoaderComponent height={100} width={100}></LoaderComponent>
                    }
                    {
                        !isLoading && <div className="table-responsive">
                            <div className='table-responsive'>
                                <TableComponent
                                    columns={columns}
                                    data={data}
                                    onDelete={onDelete}
                                    onEdit={onEdit}
                                    onCopy={onCopy}
                                    onFaqs={onFaqs}
                                    isCopyBtn={true}
                                    isFaqsBtn={true}>
                                </TableComponent>
                            </div>
                            <nav aria-label="Page navigation example">
                                <ul className="pagination justify-content-end">
                                    <li className="page-item disabled">
                                        {isPrev ? <button className="btn btn-outline-primary btn-sm me-2" onClick={prevPage}>Previous</button> : ""}
                                    </li>
                                    <li className="page-item">
                                        {isNext ? <button className="btn btn-outline-primary btn-sm" onClick={nextPage}>Next</button> : ""}
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}

export default PostsListComponent;

